import { Autocomplete, InputAdornment, InputProps } from "@mui/material";
import { ReactComponent as SearchIcon } from "../../../../common/icons/search-icon.svg";
import CommonTextField from "../commonTextField/CommonTextField";

type Props = {
  value: string;
  onInputChange: (newValue: string, reason: string) => void;
  placeholder?: string;
  InputProps?: InputProps;
  fullWidth?: boolean;
};

const SearchInput = ({
  value,
  onInputChange,
  placeholder = "",
  InputProps = {},
  fullWidth = true,
}: Props) => {
  return (
    <Autocomplete
      freeSolo
      open={false}
      options={[]}
      value={value}
      onInputChange={(_, newValue: string | number, reason: string) =>
        onInputChange(newValue.toString(), reason)
      }
      fullWidth={fullWidth}
      size="small"
      renderInput={(params) => (
        <CommonTextField
          {...params}
          placeholder={placeholder}
          InputProps={{
            startAdornment: (
              <InputAdornment position="start">
                <SearchIcon />
              </InputAdornment>
            ),
            ...InputProps,
          }}
        />
      )}
    />
  );
};

export default SearchInput;
